/*
  Protocol state
*/
export default {
  default: []
}
